import { motion } from 'framer-motion';
import { IconPhone, IconMail, IconBrandVk, IconBrandInstagram, IconClock, IconMapPin } from '@tabler/icons-react';
import { Card } from '../components/ui/card';

const ContactsPage = () => {
  return (
    <div className="min-h-screen bg-background bg-noise">
      <motion.section
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.2, ease: 'easeOut' }}
        className="py-12 sm:py-16"
      >
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="font-['Playfair_Display'] text-4xl sm:text-5xl text-center mb-6">Контакты</h1>
          <p className="text-lg text-center text-[color:hsl(var(--foreground))]/70 max-w-2xl mx-auto mb-12">
            Свяжитесь с нами удобным способом
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            {/* Телефон */}
            <Card className="bg-card border-[0.5px] border-[color:hsl(var(--hairline))] rounded-[128px] p-8">
              <IconPhone size={40} className="text-[color:hsl(var(--brand-orange))] mb-4" />
              <h2 className="font-medium text-xl mb-2">Телефон</h2>
              <a href="tel:+78462028880" className="text-2xl font-['Playfair_Display'] text-[color:hsl(var(--brand-orange))] hover:opacity-80 transition-opacity">
                8 (846) 202-88-80
              </a>
              <p className="text-sm text-[color:hsl(var(--foreground))]/70 mt-2">Единый номер для всех салонов</p>
            </Card>

            {/* Email */}
            <Card className="bg-card border-[0.5px] border-[color:hsl(var(--hairline))] rounded-[128px] p-8">
              <IconMail size={40} className="text-[color:hsl(var(--brand-orange))] mb-4" />
              <h2 className="font-medium text-xl mb-2">Email</h2>
              <a href="mailto:info@riosamara.ru" className="text-xl text-[color:hsl(var(--brand-orange))] hover:opacity-80 transition-opacity">
                info@riosamara.ru
              </a>
              <p className="text-sm text-[color:hsl(var(--foreground))]/70 mt-2">Ответим в течение 24 часов</p>
            </Card>

            {/* Режим работы */}
            <Card className="bg-card border-[0.5px] border-[color:hsl(var(--hairline))] rounded-[128px] p-8">
              <IconClock size={40} className="text-[color:hsl(var(--brand-orange))] mb-4" />
              <h2 className="font-medium text-xl mb-2">Режим работы</h2>
              <p className="text-lg">Ежедневно<br/>с 9:00 до 21:00</p>
              <p className="text-sm text-[color:hsl(var(--foreground))]/70 mt-2">Без выходных и перерывов</p>
            </Card>

            {/* Социальные сети */}
            <Card className="bg-card border-[0.5px] border-[color:hsl(var(--hairline))] rounded-[128px] p-8">
              <div className="flex items-center gap-3 mb-4">
                <IconBrandVk size={40} className="text-[color:hsl(var(--brand-orange))]" />
                <IconBrandInstagram size={40} className="text-[color:hsl(var(--brand-orange))]" />
              </div>
              <h2 className="font-medium text-xl mb-2">Соцсети</h2>
              <div className="space-y-2">
                <a href="https://vk.com/rio.samara63" target="_blank" rel="noopener noreferrer" className="block text-[color:hsl(var(--brand-orange))] hover:opacity-80 transition-opacity">
                  vk.com/rio.samara63
                </a>
                <a href="#" className="block text-[color:hsl(var(--brand-orange))] hover:opacity-80 transition-opacity">
                  @rio_samara
                </a>
              </div>
            </Card>
          </div>

          {/* Реквизиты */}
          <div className="mt-12 max-w-4xl mx-auto">
            <Card className="bg-card border-[0.5px] border-[color:hsl(var(--hairline))] rounded-[128px] p-8">
              <IconMapPin size={40} className="text-[color:hsl(var(--brand-orange))] mb-4" />
              <h2 className="font-medium text-xl mb-4">Реквизиты</h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm">
                <div>
                  <p className="text-[color:hsl(var(--foreground))]/60 mb-1">ИП</p>
                  <p className="font-medium">Воропаева Ольга Альбертовна</p>
                </div>
                <div>
                  <p className="text-[color:hsl(var(--foreground))]/60 mb-1">ИНН</p>
                  <p className="font-medium">631895770403</p>
                </div>
                <div>
                  <p className="text-[color:hsl(var(--foreground))]/60 mb-1">Юридический адрес</p>
                  <p className="font-medium">443063, Самара, ул. Александра Матросова, д 25, кв 22</p>
                </div>
                <div>
                  <p className="text-[color:hsl(var(--foreground))]/60 mb-1">ОГРНИП</p>
                  <p className="font-medium">318631300002871</p>
                </div>
              </div>
            </Card>
          </div>
        </div>
      </motion.section>
    </div>
  );
};

export default ContactsPage;